import { useEffect } from "react";

const useCheckForUpdates = () => {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/asset-manifest.json", { cache: "no-store" });

        if (!response.ok) {
          // console.error("Не удалось загрузить манифест обновлений");
          return;
        }

        const manifest = await response.json();
        const newJsFile = manifest.files?.["main.js"];

        if (!newJsFile) {
          // console.error("Файл main.js не найден в манифесте");
          return;
        }

        const currentJsFile = localStorage.getItem("appMainJs");

        if (currentJsFile && currentJsFile !== newJsFile) {
          // console.log("Новая версия приложения доступна! Перезагрузка...");
          localStorage.setItem("appMainJs", newJsFile);
          window.location.reload(true);
        }

        if (!currentJsFile) {
          localStorage.setItem("appMainJs", newJsFile);
        }
      } catch (error) {
        // console.error("Ошибка при проверке обновления:", error);
      }
    };

    // Первая проверка сразу при загрузке
    checkVersion();

    // Дальнейшие проверки каждую минуту
    const interval = setInterval(checkVersion, 60000);
    return () => clearInterval(interval);
  }, []);
};

export default useCheckForUpdates;
